<div class="main-content py-2 px-0 px-lg-2">
  <div class="messages-actions">
    <ul class="list-inline mb-3 mb-sm-5">
      <li class="list-inline-item">
        <ng-container *ngIf="!showMultiAction; else showMultiActionBLock">
          <button
            mat-stroked-button
            color="primary"
            class="shadow btn btn-sm mt-2"
            (click)="onComposeNew()"
          >
            <span translate class="translate">pages.newRetailer.compose</span>
          </button>
        </ng-container>
      </li>
      <ng-template #showMultiActionBLock>
        <ul class="list-inline multi-action-blk mx-3 mt-2">
          <li class="list-inline-item">
            <mat-checkbox
              class="check-box"
              [(ngModel)]="selectAll"
              (change)="onSelectAll($event.checked)"
              color="primary"
              >All</mat-checkbox
            >
          </li>
          <li class="list-inline-item ms-4">
            <button mat-stroked-button (click)="onDelete()">
              <i class="mi mi-delete me-2"></i>Delete
            </button>
          </li>
        </ul>
      </ng-template>
      <li class="list-inline-item">
        <button
          mat-stroked-button
          class="shadow"
          [ngClass]="{ 'active-tab': isInboxActive }"
          (click)="onClickInbox($event)"
        >
          <span translate class="translate">pages.newRetailer.inbox</span>
        </button>
      </li>
      <li class="list-inline-item btn-middle">
        <button
          mat-stroked-button
          class="shadow"
          [ngClass]="{ 'active-tab': isSentActive }"
          (click)="onClickSent($event)"
        >
          <span translate class="translate">pages.newRetailer.sent</span>
        </button>
      </li>
      <li class="list-inline-item">
        <button
          mat-stroked-button
          class="shadow"
          [ngClass]="{ 'active-tab': isDeletedActive }"
          (click)="onClickDeleted($event)"
        >
          <span translate class="translate">pages.newRetailer.deleted</span>
        </button>
      </li>
      <li class="list-inline-item" >
        <button  [ngStyle]="{'display': userRole === 'Super Admin' ||  userRole === 'Sub Admin'|| userRole === 'Customer Service' ?'block':'none'}"
          mat-stroked-button
          class="shadow"
          (click)="onClickBulkSend()"
        >
          <span translate class="translate">Bulk Compose</span>
        </button>
      </li>
      <li class="list-inline-item " style="position: fixed; top: 6rem">
        <input
          type="text"
          placeholder="{{ 'pages.newRetailer.search' | translate }}"
          matInputs
          class="
            rounded-pill
            px-3
            py-2
            mb-0
            border-0
            w-100
            me-0
            input-search
            ms-3
          "
          (keyup)="quickSearch()"
          [(ngModel)]="searchValue"
        />
        <i
          color="primary"
          class="search-icon-holder"
          matSuffix
          mat-icon-button
          aria-label="Search"
        >
          <mat-icon>search</mat-icon>
        </i>
      </li>
    </ul>
  </div>
  <div class="messages-container">
    <mat-card class="shadow-none p-0">
      <ag-grid-angular
        style="width: 100%; height: 70vh"
        class="ag-theme-material"
        #agGrid
        id="myGrid"
        [rowHeight]="40"
        [rowSelection]="'multiple'"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
        [floatingFilter]="false"
        [rowClassRules]="rowClassRules"
        [paginationPageSize]="10"
        [pagination]="true"
      >
      </ag-grid-angular>
    </mat-card>
  </div>
</div>
